export default function ComparePill({ sites, compareIds, onOpen, onClear }) {
  if (!compareIds.length) return null;
  const names = compareIds.map((id) => sites.find((s) => s.id === id)?.name.split(" ")[0]);
  const ready = compareIds.length === 2;
  return (
    <div className="flex items-center overflow-hidden rounded-full border border-[#38BDF8]/50 bg-[#12141C]/90 shadow-lg shadow-black/40 backdrop-blur">
      <button
        data-testid="compare-pill"
        onClick={onOpen}
        disabled={!ready}
        className="flex items-center gap-2.5 px-5 py-3 font-mono text-[10px] tracking-[0.25em] text-[#38BDF8] transition-colors duration-300 enabled:hover:bg-[#38BDF8] enabled:hover:text-[#0B0C10] disabled:cursor-default"
      >
        ⇄{" "}
        {ready ? (
          <>
            <span className="sm:hidden">COMPARE</span>
            <span className="hidden sm:inline">
              COMPARE {names[0].toUpperCase()} · {names[1].toUpperCase()}
            </span>
          </>
        ) : (
          <>
            <span className="sm:hidden">1/2</span>
            <span className="hidden sm:inline">COMPARE · 1/2 — PIN ONE MORE</span>
          </>
        )}
      </button>
      <button
        data-testid="compare-pill-clear"
        onClick={onClear}
        aria-label="Clear comparison"
        className="border-l border-[#38BDF8]/30 px-3 py-3 font-serif text-base leading-none text-white/45 transition-colors hover:text-[#FF9F1C]"
      >
        ×
      </button>
    </div>
  );
}
